<template>
  <div>
    <template-breadcrumb-header-action-element>
      <template #content>
        <a
          v-if="pdfStatus"
          class="exportPDF"
          :href="pdfUrl"
          target="_blank"
          size="sm"
          variant="primary"
          ><img width="40" src="/static/icons/PDF.svg"
        /></a>
        <div
          v-if="!pdfStatus"
          style="filter: saturate(0)"
          class="exportPDF"
          target="_blank"
          size="sm"
          variant="primary"
          @click="generatePdf()"
          :title="$t('label_download_PDF')"
        >
          <img width="40" src="/static/icons/PDF.svg" />
        </div>
      </template>
    </template-breadcrumb-header-action-element>

    <b-container v-if="!getIsLoading">
      <div v-for="(section, index) in sections" :key="index">
        <b-row>
          <b-col>
            <card-employment-policies-management
              :employment-policies-section="section.employmentPolicies"
              :title="section.title"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" lg="6">
            <card-indicator-info-gender-gap
              :pillar-id="section.pillar"
              :indicator-id="section.indicator"
              :height="mdScreen ? 'auto' : '430px'"
            />
          </b-col>
          <b-col md="12" lg="6">
            <card-chart-gauge
              :pillar-id="section.pillar"
              :indicator-id="section.indicator"
              :alias="'gauge' + section.indicator + section.pillar + index"
              :height="mdScreen ? 'auto' : '430px'"
            />
          </b-col> </b-row
        >
      </div>
    </b-container>
    <b-modal v-model="openDialog">
      <div v-if="modalType === 'pdf'">
        <div v-if="!pdfStatus">
          <h5 style="margin-bottom: 20px">Generating PDF report</h5>
          <div>{{ $t("label_reports_generate_report") }}</div>
        </div>
        <div v-if="pdfStatus">
          <h5 style="margin-bottom: 20px">PDF report</h5>
          <div>
            Your report is ready. Click
            <a :href="pdfUrl" target="_blank">here</a> to download it.
          </div>
        </div>
      </div>
      <div v-if="modalType === 'ppt'">
        <div v-if="!pptStatus">
          <h5 style="margin-bottom: 20px">Generating Power Point report</h5>
          <div>{{ $t("label_reports_generate_report") }}</div>
        </div>
        <div v-if="pptStatus">
          <h5 style="margin-bottom: 20px">Power Point report</h5>
          <div>
            Your report is ready. Click
            <a :href="pptUrl" target="_blank">here</a> to download it.
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button variant="primary" @click="openDialog = false">
          Close
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { axiosCall } from "@/utils/axiosCall";

export default {
  name: "ReportsManagementReport",
  data: function () {
    return {
      pdfStatus: null,
      pdfUrl: null,
      openDialog: false,
      lastGenerationPdf: null,
      modalType: null,

      mdScreen: false,
      sections: [
        {
          employmentPolicies: "internalExternalCommunication",
          title:
            "label_reports_managementReport_internalExternalCommunication_lettlerhead_title",
          pillar: "COM",
          indicator: "COM1",
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_recruitment",
          title: "label_reports_managementReport_recruitment_lettlerhead_title",
          pillar: "RSH",
          indicator: "RSH3",
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_promotion",
          title: "label_reports_managementReport_promotion_lettlerhead_title",
          pillar: "PDP",
          indicator: "PDP3",
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_training",
          title: "label_reports_managementReport_training_lettlerhead_title",
          pillar: "PDP",
          indicator: "PDP7",
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_wages",
          title: "label_reports_managementReport_wages_lettlerhead_title",
          pillar: "R",
          indicator: "R4",
        },
        {
          employmentPolicies:
            "selfAssessment_employmentPolicies_preventionSexualHarassment",
          title:
            "label_reports_managementReport_preventionSexualHarassment_letterhead_title",
          pillar: "PH",
          indicator: "PH2",
        },
        {
          employmentPolicies: "selfAssessment_employmentPolicies_wlbs",
          title: "label_reports_managementReport_wlbs_lettlerhead_title",
          pillar: "WLBS",
          indicator: "WLBS4",
        },
      ],
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters([
      "pillarsIds",
      "getToken",
      "getBusiness",
      "getCurrentSnapshot",
      "getCurrentAccountRoleId",
      "getIsLoading"
    ]),
  },
  created: async function () {
    this.$store.commit("setReportData", null);
    this.$store.commit("setEmploymentPolicies", null);
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");

    this.$store
      .dispatch("PILLARS_GET_REPORT")
      .then(() => {
      })
      .catch((err) => {
        console.log(err);
      });
    await this.checkExistence();
    this.checkAllFilesExist();
  },
  mounted() {
    if (window.innerWidth <= 992) {
      this.mdScreen = true;
    }
  },
  beforeDestroy() {
    clearInterval();
  },
  methods: {
    checkAllFilesExist() {
      setInterval(() => this.checkExistence(), 20000);
    },
    checkExistence: async function () {
      if (!this.pptStatus) {
        await axiosCall({
          url: `ReportGenerations/existsInAmazon/ppt/management-report/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}?noSpinner=true`,
        }).then((response) => {
          this.pptStatus = response.data.url.exists;
          this.pptUrl = response.data.url.url;
          this.lastGenerationPpt = response.data.url.last;
        });
      }
      if (!this.pdfStatus) {
        await axiosCall({
          url: `ReportGenerations/existsInAmazon/pdf/management-report/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}?noSpinner=true`,
        }).then((response) => {
          this.pdfStatus = response.data.url.exists;
          this.pdfUrl = response.data.url.url;
          this.lastGenerationPdf = response.data.url.last;
        });
      }
      if (this.pdfStatus && this.pptStatus) {
        clearInterval();
      }
    },
    generatePdf: async function () {
      await axiosCall({
        url: `ReportGenerations/pdf/management-report/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}`,
      });
      this.modalType = "pdf";
      this.openDialog = true;
    },
  },
};
</script>

<style lang="sass" scoped>

@import "../assets/css/variables.scss"

.positive
    background-color: $positive-color

.map
  position: relative
  margin-top: 20px
  .btn
    cursor: pointer
    position: absolute
    top: 0px
    right: 30px
    z-index: 100

h3
  font-size: 1.5rem
  margin-top: 20px
</style>
